module.exports = __webpack_public_path__ + "img/19.f9a70abf.png";